var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmptyTemplates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-empty-templates",
    transform: "translate(-767 -561)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_135",
    "data-name": "Ellipse 135",
    cx: 60,
    cy: 60,
    r: 60,
    transform: "translate(767 561)",
    fill: "#1a1b43",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3855",
    "data-name": "Group 3855",
    transform: "translate(797 591)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1538",
    "data-name": "Rectangle 1538",
    width: 60,
    height: 60,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2519",
    "data-name": "Path 2519",
    d: "M56.638,11.738a2,2,0,0,0-1.29-.822L45,9.092V3a2,2,0,0,0-2-2H3A2,2,0,0,0,1,3V55a2,2,0,0,0,2,2H43a2,2,0,0,0,2-2V50.226l3.312.584a1.862,1.862,0,0,0,.348.032,2,2,0,0,0,1.968-1.652l6.34-35.956A1.985,1.985,0,0,0,56.638,11.738ZM41,53H5V5H41Zm6.038-6.474L45,46.166V13.154l7.684,1.354Z",
    transform: "translate(-1 -1)",
    fill: "#1a1b43"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3869",
    "data-name": "Group 3869",
    transform: "translate(8 14)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3860",
    "data-name": "Group 3860"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3857",
    "data-name": "Group 3857"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2520",
    "data-name": "Path 2520",
    d: "M11,12H7A2,2,0,0,1,7,8h4a2,2,0,0,1,0,4Z",
    transform: "translate(-5 -8)",
    fill: "#1a1b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3858",
    "data-name": "Group 3858",
    transform: "translate(9.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2521",
    "data-name": "Path 2521",
    d: "M16.431,12H11.857a2,2,0,0,1,0-4h4.574a2,2,0,0,1,0,4Z",
    transform: "translate(-9.857 -8)",
    fill: "#1a1b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3859",
    "data-name": "Group 3859",
    transform: "translate(20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2522",
    "data-name": "Path 2522",
    d: "M21,12H17a2,2,0,0,1,0-4h4a2,2,0,0,1,0,4Z",
    transform: "translate(-15 -8)",
    fill: "#1a1b43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3864",
    "data-name": "Group 3864",
    transform: "translate(0 11.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3861",
    "data-name": "Group 3861",
    transform: "translate(0 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2523",
    "data-name": "Path 2523",
    d: "M11,18H7a2,2,0,0,1,0-4h4a2,2,0,0,1,0,4Z",
    transform: "translate(-5 -14)",
    fill: "#1a1b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3862",
    "data-name": "Group 3862",
    transform: "translate(9.766)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2524",
    "data-name": "Path 2524",
    d: "M11.883,18a2,2,0,0,1,0-4l4.612,0h0a2,2,0,0,1,0,4l-4.612,0Z",
    transform: "translate(-9.883 -13.998)",
    fill: "#1a1b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3863",
    "data-name": "Group 3863",
    transform: "translate(20.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2525",
    "data-name": "Path 2525",
    d: "M21.073,18h-4a2,2,0,0,1,0-4h4a2,2,0,0,1,0,4Z",
    transform: "translate(-15.073 -13.998)",
    fill: "#1a1b43"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3868",
    "data-name": "Group 3868",
    transform: "translate(0 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3865",
    "data-name": "Group 3865"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2526",
    "data-name": "Path 2526",
    d: "M11,24H7a2,2,0,0,1,0-4h4a2,2,0,0,1,0,4Z",
    transform: "translate(-5 -20)",
    fill: "#1a1b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3866",
    "data-name": "Group 3866",
    transform: "translate(9.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2527",
    "data-name": "Path 2527",
    d: "M16.431,24H11.857a2,2,0,1,1,0-4h4.574a2,2,0,0,1,0,4Z",
    transform: "translate(-9.857 -20)",
    fill: "#1a1b43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3867",
    "data-name": "Group 3867",
    transform: "translate(20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2528",
    "data-name": "Path 2528",
    d: "M21,24H17a2,2,0,0,1,0-4h4a2,2,0,0,1,0,4Z",
    transform: "translate(-15 -20)",
    fill: "#1a1b43"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmptyTemplates);
export default __webpack_public_path__ + "static/media/icon-empty-templates.910913ef0e9b922f9c9cc09169d68579.svg";
export { ForwardRef as ReactComponent };